"use es6";

import { __assign } from "apollo-stack-hubspot/internal/tslib/tslib";
import { invariant } from "apollo-stack-hubspot/@apollo/client/utilities/globals/index";
import * as React from "react";
import { getApolloContext } from "apollo-stack-hubspot/@apollo/client/react/context/ApolloContext";
export var ApolloProvider = function ApolloProvider(_a) {
  var client = _a.client,
    children = _a.children;
  var ApolloContext = getApolloContext();
  var parentContext = React.useContext(ApolloContext);
  var context = React.useMemo(function () {
    return __assign(__assign({}, parentContext), {
      client: client || parentContext.client
    });
  }, [parentContext, client]);
  invariant(context.client, 47);
  return /*#__PURE__*/React.createElement(ApolloContext.Provider, {
    value: context
  }, children);
};